const countryData = [
    {
      name: "Argentina",
      flag: "🇦🇷",
      cities: ["Buenos Aires", "Córdoba", "Rosario"],
      names: [
        "Lucía", "Martín", "Sofía", "Emilia", "Julián", "Valentina",
      ]
    },
    {
      name: "México",
      flag: "🇲🇽",
      cities: ["Ciudad de México", "Guadalajara", "Monterrey", "Puebla"],
      names: [
        "Juan", "María", "José", "Guadalupe", "Luis", "Ana",
        "Fernando", "Paola"
      ]
    },
    {
      name: "Colombia",
      flag: "🇨🇴",
      cities: ["Bogotá", "Medellín", "Cali", "Barranquilla"],
      names: [
        "Carlos", "Laura", "Andrés", "Daniela", "Camilo", "Juliana",
        "Sebastián", "Isabella"
      ]
    },
    {
      name: "Brasil",
      flag: "🇧🇷",
      cities: ["São Paulo", "Rio de Janeiro", "Brasília", "Salvador"],
      names: [
        "Lucas", "Beatriz", "Gabriel", "Ana", "Mateus", "Julia",
        "Rafael", "Larissa"
      ]
    },
    {
      name: "Estados Unidos",
      flag: "🇺🇸",
      cities: ["Miami", "New York", "Los Angeles", "Houston", "Chicago", "Boston", "West Palm Beach", "Atlanta", "Nashville", "New Orleans", "Dallas", "Austin", "West Palm Beach", "Syracuse", "Toronto", "Cincinnati", "Detroit", "Denver", "Phoenix"],
      names: [
        "James", "Emily", "Michael", "Emma", "John", "Olivia",
        "David", "Sophia", "Robert", "Ava", "William", "Mia",
        "Daniel", "Isabella", "Joseph", "Charlotte", "Chris", "Jessica",
        "Matthew", "Ashley", "Anthony", "Sarah", "Donald", "Kimberly",
        "Mark", "Deborah", "Paul", "Stephanie", "Steven", "Amanda",
        "Andrew", "Melissa", "Kevin", "Laura", "Brian", "Rebecca",
        "George", "Sharon", "Edward", "Cynthia", "Ronald", "Kathleen",
        "Timothy", "Amy", "Jason", "Shirley", "Jeffrey", "Angela",
        "Ryan", "Helen", "Jacob", "Anna", "Gary", "Brenda", "Dylan", "Lydia", "Amir", "Iryna", "Candice", "Deanna", "Ariadna", "Chloe", "Shantea", "Lakeya", "Brenda", "Shetisha", "Shawrice", "Cassaundra"
      ]
    },
    {
      name: "Ecuador",
      flag: "🇪🇨",
      cities: ["Guayaquil", "Quito"],
      names: [
        "Rafael", "Jonathan", "Gabriel", "Carolina", "Juan", "Ana", "Samuel"
      ]
    }
  ];
  
  // Barcos hardcodeados como fallback
  const fallbackBoats = [
    { id: 1, name: "Azimut 66ft" },
    { id: 2, name: "Azimut 94ft" },
    { id: 3, name: "Azimut Flybridge 75ft" },
    { id: 4, name: "Azimut Flybridge 53ft" },
    { id: 5, name: "Explorer 65ft" },
    { id: 6, name: "Pershing 94ft" },
    { id: 7, name: "Hurricane 25ft" },
    { id: 8, name: "Yamaha 25ft" }
  ];
  
  // Variable global para almacenar los barcos de la base de datos
  let dynamicBoats = null;
  
  const getWeightedBoat = () => {
    const boatsToUse = dynamicBoats || fallbackBoats;
    const randomBoat = boatsToUse[Math.floor(Math.random() * boatsToUse.length)];
    return {
      id: randomBoat.id,
      name: randomBoat.name
    };
  };
  
  const getRandomFromArray = (arr) => arr[Math.floor(Math.random() * arr.length)];
  
  const getTimeAgo = () => {
    const minutesAgo = Math.floor(Math.random() * 12) + 2;
    return `${minutesAgo} minutes ago`;
  };
  
  // Función para actualizar los barcos dinámicos
  export const updateDynamicBoats = (boatsFromDB) => {
    if (boatsFromDB && boatsFromDB.length > 0) {
      dynamicBoats = boatsFromDB;
    }
  };
  
  export const generateRandomMessage = () => {
    const country = getRandomFromArray(countryData);
    const name = getRandomFromArray(country.names);
    const city = getRandomFromArray(country.cities);
    const boat = getWeightedBoat();
    const time = getTimeAgo();
  
    return {
      name,
      city,
      country: country.name,
      flag: country.flag,
      boat: boat.name,
      boatId: boat.id,
      time,
    };
  };